<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text *ngIf="isLoaded" fxFlex="100" [allowHtml]="true" [mainText]="ChartSubtitle"
                           class="forge-typography--subheading1">
            </truncate-text>
        </div>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded" class="chart-container">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>

        <div *ngIf="showChart" fxLayout="row" fxLayoutAlign="end center">
            <command-bar telemetry="Menu-GenericChart" [commands]="commands"></command-bar>
        </div>
    </div>
</forge-card>
